import preferencesManager from './updatePropertySelection';

const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener('mousedown', holder.closePropertySelector);
    }
  }
};

export default {
  init: ({ selectedPropertyId, properties }, outlet) => {
    if (!selectedPropertyId) {
      const id = window.adminPreferences?.selected_property_ids[0] ?? properties[0]?.id ?? null;
      outlet({ selectedPropertyId: id });
    }
  },
  'PropertySelector.HeaderWrapper.Selector': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    internalStateSetter('isOpen', !isOpen);
    if (isOpen) {
      document.removeEventListener('mousedown', holder.closePropertySelector);
    } else {
      document.addEventListener('mousedown', holder.closePropertySelector);
    }
  },
  'PropertySelector.Body.Properties.Property': ({ id }, outlet, internalStateSetter) => {
    outlet({ selectedPropertyId: id });
    internalStateSetter('isOpen', false);
    if (window.adminPreferences) {
      window.adminPreferences.selected_property_id = id;
    }
    preferencesManager.saveAdminPreference({ ...window.adminPreferences, selected_property_id: id });
  },
  'PropertySelector.Body.Search': ({ value }, _, internalStateSetter) => {
    internalStateSetter('searchTerm', value);
  }
};
